const DATES = {
  friday: { start: "20270326T220000Z", end: "20270327T020000Z", timed: true },
  saturday: { start: "20270327T210000Z", end: "20270328T030000Z", timed: true },
  sunday: { start: "20270328", end: "20270329" },
};

const detailsFor = (ev) => `${ev.note || ""}\n\nAll details: ${window.location.origin}`;

export const googleCalUrl = (ev) => {
  const t = DATES[ev.id];
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: `${ev.title} — Paulina & Louie`,
    dates: `${t.start}/${t.end}`,
    location: `${ev.place}, ${ev.address}`,
    details: detailsFor(ev),
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const downloadIcs = (ev) => {
  const t = DATES[ev.id];
  const stamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const esc = (s) => String(s).replace(/,/g, "\\,").replace(/\n/g, "\\n");
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Paulina and Louie//Wedding//EN",
    "BEGIN:VEVENT",
    `UID:${ev.id}-paulina-louie-2027`,
    `DTSTAMP:${stamp}`,
    `DTSTART${t.timed ? ":" + t.start : ";VALUE=DATE:" + t.start}`,
    `DTEND${t.timed ? ":" + t.end : ";VALUE=DATE:" + t.end}`,
    `SUMMARY:${esc(`${ev.title} — Paulina & Louie`)}`,
    `LOCATION:${esc(`${ev.place}, ${ev.address}`)}`,
    `DESCRIPTION:${esc(detailsFor(ev))}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `paulina-louie-${ev.id}.ics`;
  a.click();
  URL.revokeObjectURL(a.href);
};
